"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.off = exports.on = void 0, exports.on = function (e, t) {
  require("../packages/frame-talk-client-pc/index.js").addEventListener(e, t);
}, exports.off = function (e, t) {
  require("../packages/frame-talk-client-pc/index.js").removeEventListener(e, t);
};